<template>
    <div class="rests_times">
        <times :times="this.rest.times"></times>
    </div>
</template>

<script>
    import times from "../../../../times/times.vue";
    export default {
        name: "restaurant_work",
        components : {
            times
        },
        props : {
            rest : {
                type : Object
            }
        },
        data() {
            return {
                cur_rest : this.rest,
                is_load: false,
            }
        },

        computed : {

        }
    }
</script>

<style scoped>

</style>
